export default __webpack_public_path__ + "static/media/home-decor-bg-img-02.b2f7bd77.jpg";